import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../Tooltip'
import styles from './side-container.scss'
import { launcherOpenUrl } from '../../launcherBackend/launcher-command'
import attributes from '../../settings/references.json'

const SideContainer = props => (
    <div className={styles.sideContainer}>
        <SideButton
            type={'feedback'}
            description={'feedback'}
            link={attributes.link.feedbackButton}
            localize={props.localize}
        />
        <SideButton
            type={'bug'}
            description={'bugreport'}
            link={attributes.link.bugReportButton}
            localize={props.localize}
        />
    </div>
)

SideContainer.propTypes = {
    localize: PropTypes.func,
}

const SideButton = props => (
    <Tooltip content={props.localize('externalLink')} type={props.type}>
        <span
            role="button"
            tabIndex="0"
            onKeyPress={event => launcherOpenUrl(props.link, event)}
            onClick={() => launcherOpenUrl(props.link)}
        >
            {props.localize(props.description)}
        </span>
    </Tooltip>
)

SideButton.propTypes = {
    type: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
    localize: PropTypes.func,
}

export default SideContainer



// WEBPACK FOOTER //
// ./src/components/SideContainer/side-container.js